var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-alert',{staticClass:"white--text text-center",attrs:{"color":"green"},on:{"click":_vm.refresh}},[_vm._v(" "+_vm._s(_vm.$t('general.newVersion'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }